import React, { useEffect, useState } from "react";
import { Alert, Card, Skeleton, Switch, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { errorText, getProfile, updateConsent } from "./api";
import { formatDateTime } from "../../../serviceProvider/components/workReports/format";
import "./portal.css";

const { Paragraph, Text } = Typography;

/**
 * The customer decides themselves how the company may contact them (appointment messages by
 * email, SMS, WhatsApp) and whether it may ask for a review. Saved with the time as their own
 * consent.
 */
const PortalConsent = () => {
  const { t, i18n } = useTranslation("dashboard");
  const [state, setState] = useState({ loading: true });
  const [saving, setSaving] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    getProfile()
      .then(res => setState({ loading: false, profile: res.data.data }))
      .catch(err =>
        setState({ loading: false, failed: errorText(err, t("Could not load your settings.")) })
      );
  }, [t]);

  const change = async (key, value) => {
    setSaving(key);
    setError("");
    try {
      const res = await updateConsent({ [key]: value });
      setState(prev => ({ ...prev, profile: { ...prev.profile, ...res.data.data } }));
    } catch (err) {
      setError(errorText(err, t("Your choice could not be saved.")));
    } finally {
      setSaving("");
    }
  };

  if (state.loading) return <Skeleton active />;
  if (state.failed) return <Alert type="error" showIcon message={state.failed} />;

  const consent = state.profile.messagingConsent;
  const rows = [
    { key: "email", label: t("Appointment messages by email") },
    { key: "sms", label: t("Appointment messages by SMS") },
    { key: "whatsapp", label: t("Appointment messages by WhatsApp") },
    { key: "reviews", label: t("Requests for a review after the job") }
  ];

  return (
    <Card title={t("Notifications")} className="portal-page portal-card">
      <Paragraph type="secondary">
        {t("Choose how {{company}} may contact you. You can change this at any time.", {
          company: state.profile.provider?.name || ""
        })}
      </Paragraph>
      {error && <Alert className="portal-gap" type="error" showIcon message={error} />}
      <ul className="portal-consent">
        {rows.map(row => (
          <li key={row.key}>
            <label htmlFor={`consent-${row.key}`}>{row.label}</label>
            <Switch
              id={`consent-${row.key}`}
              checked={consent[row.key]}
              loading={saving === row.key}
              onChange={value => change(row.key, value)}
            />
          </li>
        ))}
      </ul>
      {!state.profile.phone && (
        <Text type="secondary">
          {t("For SMS and WhatsApp please add your mobile number to your profile.")}
        </Text>
      )}
      {consent.updatedAt && (
        <Paragraph type="secondary" className="portal-gap-top">
          {t("Last changed {{date}}", { date: formatDateTime(consent.updatedAt, i18n.language) })}
        </Paragraph>
      )}
    </Card>
  );
};

export default PortalConsent;
